export const MAX_VALUE_AMOUNT = 999999999999999;
export const MIN_VALUE_AMOUNT = -999999999999999;

// Max length constants for instruction form validations
export const INSTRUCTION_TITLE_MAX_LENGTH = 100;
export const INSTRUCTION_CONTENT_MAX_LENGTH = 2000;
export const INSTRUCTION_DESTINATION_MAX_LENGTH = 100;
export const INSTRUCTION_SENDER_MAX_LENGTH = 100;
